import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import './Tabs.scss';

export default function DashboardTabs({ tabs, onChangeTab }) {
  return (
    <Grid container justifyContent="center" marginTop={6} marginBottom={5}>
      {tabs.map((tab) => (
        <Grid item xs={12} sm={2} key={tab.id} sx={{ textAlign: 'center' }}>
          <button
            type="button"
            onClick={() => onChangeTab(tab.id)}
            className={`dashboard-tabs__title ${tab.active && 'dashboard dashboard-tabs--active'}`}>
            {tab.name}
          </button>
        </Grid>
      ))}
    </Grid>
  );
}

DashboardTabs.propTypes = {
  onChangeTab: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
    }).isRequired,
  ).isRequired,
};
